import React from 'react';
import DeviceScanCard from '../../../../components/DeviceScan/DeviceScanCard';
import useDeviceScanSession from '../../../../components/DeviceScan/useDeviceScanSession';

function DeviceScan(props) {
    const { legal_person } = props;
    const { deviceScan, sdkMetadata } = useDeviceScanSession(
        legal_person.company_key,
        legal_person.source?.session_id
    );

    return (
        <DeviceScanCard
            deviceScan={deviceScan}
            channel={legal_person.source?.channel}
            sdkMetadata={sdkMetadata}
        />
    );
}

export default DeviceScan;
